import { isAndroidBuild } from './isAndroidBuild';
import { isWebBuild } from './isWebBuild';

/** Checks if react native app is running in development build.
 *
 * Just a semantic wrapper for the __DEV__ env variable
 */
export const is_dev_build = __DEV__;

export const isDevBuild = () => {
  if (isAndroidBuild()) {
    return __DEV__;
  }

  if (isWebBuild()) {
    return process.env.NODE_ENV && process.env.NODE_ENV === 'development';
  }

  return false;
};
